module.exports = __webpack_public_path__ + "img/recruit-main.3566a739.jpg";